import { Input, Modal } from 'antd';
import { useCallback, useEffect, useRef, useState } from 'react'
import { updateProject } from '../../../../actions';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import TextEditor from '../editor/TextEditor';
import HtmlRenderer from '../../organisms/HtmlRenderer';
import { toggleEditProjectDetailsModal } from '../../../../actions/modalAction';
import _debounce from 'lodash/debounce';
import WorkspaceMemberRow from '../../atoms/invite-modal/WorkspaceMemberRow';

const MODAL_STYLES = {
    body: {
        backgroundColor: '#FFFFFF',
        borderTop: '1px solid #ccc',
        borderBottomLeftRadius: '10px',
        borderBottomRightRadius: '10px',
    },
    header: {
        padding: '10px 15px',
    },
    title: {
        fontSize: '16px',
    },
};

const EditProjectDetailsModal = ({ project, isModalOpen }) => {
    const dispatch = useDispatch();
    const intl = useIntl()

    const [description, setDescription] = useState('');
    const [isEditDesc, setIsEditDesc] = useState(false);
    const [name, setName] = useState('');
    const inputRef = useRef(null);

    useEffect(() => {
        if (project?.title) {
            setName(project.title);
        }
    }, [project]);

    const updateProjectInfo = useCallback(
        _debounce((value) => {
            if (value.trim() && value.trim() !== project?.title) {
                dispatch(updateProject({ _id: project?._id, title: value.trim() }));
            }
        }, 800),
        [project?._id, project?.title]
    );

    const handleBlur = () => {
        if (name.trim() && name.trim() !== project?.title) {
            updateProjectInfo(name);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            inputRef.current?.blur();
        }
    };

    const handleChange = (evt) => {
        setDescription(evt);
    };

    const descriptionHandler = () => {
        setIsEditDesc(false);
    };

    const cancelHandler = () => {
        setIsEditDesc(false);
    };

    const closeModal = () => {
        dispatch(toggleEditProjectDetailsModal(false));
    };

    return (
        <Modal
            title={intl.formatMessage({ id: 'EDIT_PROJECT_DETAILS', defaultMessage: 'Edit Project Details' })}
            open={isModalOpen}
            onCancel={closeModal}
            okButtonProps={{ style: { display: 'none' } }}
            cancelButtonProps={{ style: { display: 'none' } }}
            styles={MODAL_STYLES}
            className='custom-modal'
        >
            <div className="px-5">
                <div className="text-slate-800 mt-3 font-semibold">
                    <FormattedMessage id="PROJECT_NAME" defaultMessage="Project Name" />
                </div>
                <Input
                    ref={inputRef}
                    className='h-9 mt-2'
                    style={{ borderRadius: '7px' }}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    onBlur={handleBlur}
                    onKeyDown={handleKeyDown}
                />
            </div>
            <div className="bg-white h-full overflow-y-auto">
                <h2 className="font-semibold px-5 text-slate-800 mb-1 mt-5">
                    <FormattedMessage id="PROJECT_MEMBERS" defaultMessage="Project Members" />
                </h2>
                <div className="max-h-[25vh] px-1 overflow-y-auto">
                    {project?.participants?.length > 0 ? (
                        project.participants.map((member) => (
                            <WorkspaceMemberRow
                                key={member._id}
                                member={member}
                                isProject={true}
                                projectId={project?._id}
                            />
                        ))
                    ) : (
                        <div className="px-4 pb-3">
                            <p className="text-gray-500 text-sm mb-2">
                                <FormattedMessage id="NO_PROJECT_MEMBERS" defaultMessage="No members in this project yet." />
                            </p>                         
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    );
};




export default EditProjectDetailsModal;
